export const FormatDate = (date) => {
    if (!date || date === '1970-01-01T00:00:00.000Z' || date === '1970-01-01') return '';
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};